import * as Sentry from "@sentry/react";
import { redactSensitiveEvent } from "../utils/sensitiveData";
import { captureSurveyAccessTokenFromLocation } from "../utils/surveyAccessUrl";

const sentryDsn = process.env.REACT_APP_SENTRY_DSN;
const sentryEnvironment = process.env.REACT_APP_ENVIRONMENT || "development";

captureSurveyAccessTokenFromLocation();

if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: sentryEnvironment,
    integrations: [Sentry.consoleLoggingIntegration({ levels: ["error"] })],
    enableLogs: true,
    release: process.env.REACT_APP_VERCEL_GIT_COMMIT_SHA,
    beforeSend: redactSensitiveEvent,
    beforeSendTransaction: redactSensitiveEvent,
    beforeSendLog: redactSensitiveEvent,
    beforeBreadcrumb: redactSensitiveEvent,
  });
}

export function setSentryUser(user?: {
  userId: string;
  nickname?: string;
  clientId?: string;
}) {
  if (!user) {
    Sentry.setUser(null);
    return;
  }
  Sentry.setUser({
    id: user.userId,
    username: user.nickname,
  });
  if (user.clientId) {
    Sentry.setTag("clientId", user.clientId);
  }
}
